import React from 'react';
import { 
  Image as ImageIcon, 
  Music as MusicIcon, 
  Video as VideoIcon, 
  FileText as FileTextIcon, 
  Table as TableIcon, 
  Presentation as PresentationIcon, 
  File as FileIcon 
} from 'lucide-react';

export const getFileIcon = (mimeType: string, size: number = 14) => {
  if (mimeType.startsWith('image/')) return <ImageIcon size={size} className="text-blue-500" />;
  if (mimeType.startsWith('audio/')) return <MusicIcon size={size} className="text-purple-500" />;
  if (mimeType.startsWith('video/')) return <VideoIcon size={size} className="text-red-500" />;
  if (mimeType === 'application/pdf') return <FileTextIcon size={size} className="text-orange-500" />;
  if (mimeType.includes('spreadsheet') || mimeType.includes('excel')) return <TableIcon size={size} className="text-emerald-500" />;
  if (mimeType.includes('presentation') || mimeType.includes('powerpoint')) return <PresentationIcon size={size} className="text-amber-500" />;
  if (mimeType.includes('document') || mimeType.includes('word')) return <FileTextIcon size={size} className="text-blue-600" />;
  return <FileIcon size={size} className="text-slate-400" />;
};